import React, { memo } from 'react';
import { Tooltip } from '@mui/material';
import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { AiFillQuestionCircle } from 'react-icons/ai';
import { flex } from '~/modules/AppLayout/FlexGridCss';
const Container = styled.div `
  ${flex.v.default};
  font-size: 12px;
  width: 275px;
`;
const Title = styled.div `
  ${flex.h.allCenter};
  font-size: 14px;
  padding: 5px;
`;
const Part = styled.div `
  ${flex.h.default};
  margin: 4px 0px 4px 0px;
`;
const Item = styled.div `
  margin: 0px 6px 0px 6px;
  background-color: #777777;
  width: 80%;
  border-radius: 5px;
  padding: 5px;
`;
const ToolTipDirections = memo(function ToolTipDirections() {
    return (<div>
      <Tooltip title={<Container>
            <Title>交易績效優於富邦期貨所有客戶</Title>
            <Part>
              <Item css={css `
                  width: 40%;
                `}>
                5星 : 95%以上
              </Item>
            </Part>
            <div css={css `
                ${flex.h.default};
                width: 100%;
              `}>
              <div css={css `
                  ${flex.v.default};
                  width: 50%;
                `}>
                <Part>
                  <Item>4.5星 : 95%~85%</Item>
                </Part>
                <Part>
                  <Item>3.5星 : 75%~65%</Item>
                </Part>
                <Part>
                  <Item>2.5星 : 55%~45%</Item>
                </Part>
                <Part>
                  <Item>1.5星 : 35%~25%</Item>
                </Part>
                <Part>
                  <Item>0.5星 : 15%~5%</Item>
                </Part>
              </div>

              <div css={css `
                  ${flex.v.default};
                  width: 50%;
                `}>
                <Part>
                  <Item>4星 : 85%~75%</Item>
                </Part>
                <Part>
                  <Item>3星 : 65%~55%</Item>
                </Part>
                <Part>
                  <Item>2星 : 45%~35%</Item>
                </Part>
                <Part>
                  <Item>1星 : 25%~15%</Item>
                </Part>
                <Part>
                  <Item>0星 : 5%以下</Item>
                </Part>
              </div>
            </div>
          </Container>} arrow>
        <div css={css `
            font-size: 18px;
            color: #2196f3;
            &:hover {
              color: #1e85d9;
            }
          `}>
          <AiFillQuestionCircle />
        </div>
      </Tooltip>
    </div>);
});
export default ToolTipDirections;
